import getIsAndroid from "selectors/device/getIsAndroid";
import getIsMobileSafari from "selectors/device/getIsMobileSafari";
import { createSelector } from "reselect";

const getIsForcingChapterCover = (state) => !!state.forceChapterCover;
const getIsOnStoryCover = (state) =>
  !state.route.params.chapterKey && !state.playerOptions.singleVideoPlayer;

const getAdRequiresDirectUserInteraction = createSelector(
  [
    getIsAndroid,
    getIsForcingChapterCover,
    getIsMobileSafari,
    getIsOnStoryCover,
  ],
  (isAndroid, isForcingChapterCover, isMobileSafari, isOnStoryCover) =>
    (isAndroid || isMobileSafari) && (isForcingChapterCover || isOnStoryCover),
);

export default getAdRequiresDirectUserInteraction;
